module.exports = __webpack_public_path__ + "img/meitene-file-search.6af88392.png";